export default __webpack_public_path__ + "static/media/investmentAnalysis.ecf1ba2e.svg";